// This function allow to reference chunks
__webpack_require__.miniCssF = function(chunkId) {
  // return url for filenames not based on template
  if (chunkId === "9652") return "static/css/async/9652.css";
  // return url for filenames based on template
  return "static/css/" + {"8410": "index","9474": "vendor",}[chunkId] + ".css"
}